
__webpack_require__.S = {};
__webpack_require__.initializeSharingData = { scopeToSharingDataMapping: { "default": [{ name: "vue", version: "3.5.25", factory: () => (() => (__webpack_require__(3820))), eager: 1, singleton: 1, requiredVersion: "^3.4.0", strictVersion: 0 }] }, uniqueName: "taskbolt" };
__webpack_require__.I = __webpack_require__.I || function() { throw new Error("should have __webpack_require__.I") }
